import type { FC } from "react";
import { useEffect } from "react";
import { useEditorFocusChanged } from "../utils/use-editor-focus-changed";

export const FocusChangedPlugin: FC<{ onChange: (focused: boolean) => void }> = ({ onChange }) => {
  const focused = useEditorFocusChanged();

  useEffect(() => {
    onChange(focused);
  }, [onChange, focused]);

  return null;
};
